import { render, staticRenderFns } from "./LandingWishlistDE.vue?vue&type=template&id=2b057027&scoped=true"
import script from "./LandingWishlistDE.vue?vue&type=script&lang=js"
export * from "./LandingWishlistDE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b057027",
  null
  
)

export default component.exports